export const locationMapStyle: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 10 }] },
  { elementType: 'labels.text.fill', stylers: [{ saturation: -100 }, { lightness: 35 }] },
  { elementType: 'labels.text.stroke', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ saturation: -100 }, { lightness: 40 }],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ saturation: -100 }, { lightness: 50 }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ saturation: -100 }, { color: '#7a7a7a' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'on' }, { saturation: -100 }, { lightness: 10 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ saturation: -100 }, { lightness: 35 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'on' }, { saturation: -100 }, { lightness: 5 }],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'on' }, { saturation: -100 }, { lightness: 5 }],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ saturation: -100 }, { lightness: 40 }],
  },
];
